<template>
  <div
    @click.stop="toDetail(item)"
    class="list-item" :class="{
      'list-item-normal': size === 'normal',
      'list-item-small': size === 'small',
      'list-item-big': size === 'big',
    }">
    <div class="info">
      <h3 class="text-overflow">{{ item.title }}</h3>
      <div class="num text-overflow">{{ item.viewCount }} 人浏览</div>
    </div>
    <div class="imgBox">
      <img v-lazy="item.image" :alt="item.name">
    </div>
  </div>
</template>

<script>
import { defineComponent } from 'vue'
import { oldHostPath } from '@/public/utils/basePath'
import utils from '@utils/index'
import app from '@/widget/app'
export default defineComponent({
  props: {
    size: {
      type: String,
      default: 'normal'
    },
    item: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  methods: {
    toDetail (item) {
      if (utils.isApp()) {
        app.postMessage({
          type: 'h5',
          url: `${oldHostPath}/article/${item.articleId}`
        })
      } else {
        window.open(`${oldHostPath}/article/${item.articleId}`)
      }
    }
  }
})
</script>

<style lang="scss" scoped>
.list-item {
  width: 100%;
  display: flex;
  justify-content: space-between;
  .info {
    overflow: hidden;
    flex: 1;
    h3 {
      height: 80px;
      line-height: 40px;
      font-size: 28px;
      margin-bottom: 8px;
    }
    .num {
      color: $gray96;
    }
  }
  .imgBox {
    width: 164px;
    height: 122px;
    overflow: hidden;
    border-radius: 12px;
  }
}

</style>
